
import React from "react";
import { Button } from "@/components/ui/button";
import { Database, PlusCircle } from "lucide-react";

const EmptyAccountsTable = () => {
  const handleAddAccount = () => {
    const event = new CustomEvent('openCreateAccountDialog');
    window.dispatchEvent(event);
  };

  return (
    <div className="flex flex-col items-center justify-center py-10 border rounded-md bg-muted/10">
      <Database className="h-12 w-12 text-muted-foreground mb-4" />
      <h3 className="text-lg font-semibold mb-2">No Accounts Found</h3>
      <p className="text-muted-foreground text-sm max-w-md text-center mb-4">
        You haven't added any accounts yet. Accounts connect a lead account to a strategy for trading.
      </p>
      <Button onClick={handleAddAccount}>
        <PlusCircle className="mr-2 h-4 w-4" />
        Add Your First Account
      </Button>
    </div>
  );
};

export default EmptyAccountsTable;
